'use client';

import { useEffect } from 'react';

export default function SmoothHashScroll({
  offset = 90, // sticky header height (adjust)
}: {
  offset?: number;
}) {
  useEffect(() => {
    const getOffset = () => {
      // Use provided offset, or auto-detect header height if you prefer:
      const header = document.querySelector('header');
      return header ? header.getBoundingClientRect().height : offset;
    };

    const scrollToId = (id: string) => {
      const el = document.getElementById(id);
      if (!el) return;

      const y = el.getBoundingClientRect().top + window.scrollY - getOffset();
      window.scrollTo({ top: y, behavior: 'smooth' });
    };

    // Handle clicks on <a href="#section">
    const onClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      const a = target?.closest('a[href^="#"]') as HTMLAnchorElement | null;
      if (!a) return;

      const href = a.getAttribute('href') || '';
      if (href === '#' || href.length < 2) return;

      const id = href.slice(1);

      // If element exists on this page, smooth scroll instead of jump
      if (document.getElementById(id)) {
        e.preventDefault();
        // Keep URL hash updated without jump
        history.pushState(null, '', href);
        scrollToId(id);
      }
    };

    // Handle direct load with hash (e.g. /#app)
    const onLoadHash = () => {
      const hash = window.location.hash;
      if (!hash || hash.length < 2) return;
      const id = hash.slice(1);

      // Wait a tick for layout/fonts
      setTimeout(() => scrollToId(id), 50);
    };

    document.addEventListener('click', onClick, true);
    window.addEventListener('hashchange', onLoadHash);

    // initial hash load
    onLoadHash();

    return () => {
      document.removeEventListener('click', onClick, true);
      window.removeEventListener('hashchange', onLoadHash);
    };
  }, [offset]);

  return null;
}